(function () {
  function parseVariants(root) {
    var pid = root.getAttribute('data-product-id');
    var el = document.getElementById('BeBackInStockVariants-' + pid);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function findVariant(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (Number(list[i].id) === Number(id)) return list[i];
    }
    return null;
  }

  function getRoot() {
    return document.querySelector('[data-bis-root]');
  }

  function setMsg(root, text, ok) {
    var msg = root.querySelector('[data-bis-msg]');
    if (!msg) return;
    if (!text) {
      msg.hidden = true;
      msg.textContent = '';
      return;
    }
    msg.hidden = false;
    msg.textContent = text;
    msg.classList.toggle('be-bis__msg--ok', !!ok);
    msg.classList.toggle('be-bis__msg--err', !ok);
  }

  function openModal(root, variant) {
    if (!root || !variant) return;
    root._bisVariant = variant;
    var label = root.querySelector('[data-bis-variant-label]');
    if (label) label.textContent = variant.title || '';
    var overlay = root.querySelector('[data-bis-overlay]');
    var panel = root.querySelector('[data-bis-panel]');
    if (overlay) {
      overlay.hidden = false;
      overlay.removeAttribute('hidden');
      overlay.style.display = 'flex';
    }
    if (panel) {
      panel.hidden = false;
      panel.removeAttribute('hidden');
      panel.style.display = 'grid';
    }
    document.documentElement.classList.add('be-bis-open');
    setMsg(root, '', true);
    var phone = root.querySelector('[data-bis-phone]');
    if (phone) setTimeout(function () { phone.focus(); }, 80);
  }

  function closeModal(root) {
    if (!root) root = getRoot();
    if (!root) return;
    var overlay = root.querySelector('[data-bis-overlay]');
    var panel = root.querySelector('[data-bis-panel]');
    if (panel) {
      panel.hidden = true;
      panel.setAttribute('hidden', '');
      panel.style.display = 'none';
    }
    if (overlay) {
      overlay.hidden = true;
      overlay.setAttribute('hidden', '');
      overlay.style.display = 'none';
    }
    document.documentElement.classList.remove('be-bis-open');
    setMsg(root, '', true);
  }

  function selectedOptions(scope) {
    var opts = { 1: null, 2: null, 3: null };
    var checked = scope.querySelectorAll(
      '.product-form__input input[type="radio"]:checked, .be-color-swatch-input:checked',
    );
    checked.forEach(function (input) {
      var name = String(input.name || '');
      var m = name.match(/-(\d+)\s*$/);
      var pos = m ? Number(m[1]) : 0;
      if (pos >= 1 && pos <= 3) opts[pos] = input.value;
    });
    return opts;
  }

  function matchVariant(list, opts) {
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      var ok = true;
      if (opts[1] != null && String(v.option1 || '') !== String(opts[1])) ok = false;
      if (opts[2] != null && String(v.option2 || '') !== String(opts[2])) ok = false;
      if (opts[3] != null && String(v.option3 || '') !== String(opts[3])) ok = false;
      if (ok) return v;
    }
    return null;
  }

  function ensureBellOnWrap(wrap, variant, sizeValue) {
    var existing = wrap.querySelector('[data-bis-size-bell]');
    var hintEl = wrap.querySelector('.be-size-bis-bell__hint');
    if (!variant || variant.available !== false) {
      if (existing) existing.remove();
      if (hintEl) hintEl.remove();
      wrap.classList.remove('be-size-wrap--bis');
      return;
    }
    wrap.classList.add('be-size-wrap--bis');
    if (!existing) {
      existing = document.createElement('button');
      existing.type = 'button';
      existing.className = 'be-size-bis-bell';
      existing.setAttribute('data-bis-size-bell', '');
      existing.innerHTML =
        '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 22a2.2 2.2 0 0 0 2.1-1.5H9.9A2.2 2.2 0 0 0 12 22Zm6.7-5.2-1.5-1.5V11a5.2 5.2 0 0 0-4.2-5.1V5a1 1 0 1 0-2 0v.9A5.2 5.2 0 0 0 6.8 11v4.3L5.3 16.8a1 1 0 0 0 .7 1.7h12a1 1 0 0 0 .7-1.7Z"/></svg>';
      wrap.appendChild(existing);
    }
    if (!wrap.querySelector('.be-size-bis-bell__hint')) {
      var hint = document.createElement('span');
      hint.className = 'be-size-bis-bell__hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.textContent = 'Gelince haber ver';
      wrap.appendChild(hint);
    }
    existing.setAttribute('data-variant-id', String(variant.id));
    existing.setAttribute('data-variant-title', variant.title || sizeValue || '');
    existing.setAttribute('data-size', sizeValue || '');
    existing.setAttribute('data-color', variant.option1 || '');
    existing.setAttribute('aria-label', (sizeValue || '') + ' — stok gelince haber ver');
    existing.title = 'Stok gelince haber ver';
  }

  function productScope(root) {
    return (
      (root && (root.closest('.be-product-buy') || root.closest('.product') || root.closest('product-info'))) ||
      document.querySelector('product-info') ||
      document.querySelector('.product') ||
      document
    );
  }

  function syncSizeBells(root) {
    if (!root) root = getRoot();
    if (!root) return;
    var list = parseVariants(root);
    var scope = productScope(root);
    var opts = selectedOptions(scope);
    var wraps = scope.querySelectorAll('.be-size-wrap');
    if (wraps.length) {
      wraps.forEach(function (wrap) {
        var input = wrap.querySelector('input[type="radio"]');
        if (!input) return;
        var sizeVal = input.value;
        var name = String(input.name || '');
        var m = name.match(/-(\d+)\s*$/);
        var pos = m ? Number(m[1]) : 2;
        var tryOpts = { 1: opts[1], 2: opts[2], 3: opts[3] };
        tryOpts[pos] = sizeVal;
        ensureBellOnWrap(wrap, matchVariant(list, tryOpts), sizeVal);
      });
      return;
    }
    // Eski markup (label içinde zil) — sarmalayıcı yoksa
    var sizeInputs = scope.querySelectorAll('.be-product-form__input--size input[type="radio"]');
    sizeInputs.forEach(function (input) {
      var label = scope.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (!label) return;
      var wrap = label.parentElement;
      if (!wrap || !wrap.classList.contains('be-size-wrap')) {
        // zili label dışına taşı
        if (!wrap || wrap === scope) return;
      }
    });
  }

  function variantFromBell(btn, list) {
    var vid = Number(btn.getAttribute('data-variant-id'));
    var v = findVariant(list, vid);
    if (v) return v;
    return {
      id: vid,
      title: btn.getAttribute('data-variant-title') || btn.getAttribute('data-size') || '',
      option1: btn.getAttribute('data-color') || '',
      option2: btn.getAttribute('data-size') || '',
      option3: '',
      sku: '',
      barcode: '',
      available: false,
    };
  }

  function onBellActivate(ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-bis-size-bell]') : null;
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    // Label seçimini engellemek için mousedown'da da yakala; açmayı click'te yap
    if (ev.type !== 'click') return;
    var root = getRoot();
    if (!root) {
      console.warn('[be-bis] popup root bulunamadı');
      return;
    }
    var list = parseVariants(root);
    openModal(root, variantFromBell(btn, list));
  }

  function bindRoot(root) {
    if (!root || root.dataset.bisBound === '1') return;
    root.dataset.bisBound = '1';

    var overlay = root.querySelector('[data-bis-overlay]');
    var submit = root.querySelector('[data-bis-submit]');
    var closeBtn = root.querySelector('[data-bis-close]');

    if (closeBtn) closeBtn.addEventListener('click', function () { closeModal(root); });
    if (overlay) {
      overlay.addEventListener('click', function (ev) {
        if (ev.target === overlay) closeModal(root);
      });
    }

    if (submit) {
      submit.addEventListener('click', async function () {
        var v = root._bisVariant;
        if (!v) return;
        var phone = (root.querySelector('[data-bis-phone]') || {}).value || '';
        var email = (root.querySelector('[data-bis-email]') || {}).value || '';
        var consent = !!(root.querySelector('[data-bis-consent]') || {}).checked;
        if (!phone.trim() && !email.trim()) {
          setMsg(root, 'Telefon veya e-posta girin.', false);
          return;
        }
        if (!consent) {
          setMsg(root, 'Onay kutusunu işaretleyin.', false);
          return;
        }
        submit.disabled = true;
        setMsg(root, '', true);
        try {
          var api = (root.getAttribute('data-api') || '').replace(/\/$/, '');
          var handle = root.getAttribute('data-product-handle') || '';
          var baseUrl = root.getAttribute('data-product-url') || '';
          var productUrl = baseUrl;
          if (baseUrl) {
            try {
              var u = new URL(baseUrl, window.location.origin);
              u.searchParams.set('variant', String(v.id));
              productUrl = u.toString();
            } catch (e) {
              productUrl = baseUrl;
            }
          }
          var res = await fetch(api + '/subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Back-In-Stock-Key': root.getAttribute('data-store-key') || '',
            },
            body: JSON.stringify({
              uid: root.getAttribute('data-uid'),
              storeKey: root.getAttribute('data-store-key'),
              shopDomain: root.getAttribute('data-shop'),
              consent: true,
              phone: phone.trim(),
              email: email.trim(),
              shopifyVariantId: v.id,
              shopifyProductId: Number(root.getAttribute('data-product-id')),
              productTitle: root.getAttribute('data-product-title'),
              productHandle: handle,
              productUrl: productUrl,
              variantTitle: v.title,
              size: v.option2 || v.option1 || '',
              colorName: v.option1 || '',
              sku: v.sku || '',
              barcode: v.barcode || '',
            }),
          });
          var body = await res.json().catch(function () { return {}; });
          if (!res.ok || !body.ok) setMsg(root, body.error || 'Kayıt başarısız', false);
          else setMsg(root, body.message || 'Talebiniz alındı. Stok gelince haber vereceğiz.', true);
        } catch (e) {
          setMsg(root, 'Bağlantı hatası. Lütfen tekrar deneyin.', false);
        } finally {
          submit.disabled = false;
        }
      });
    }

    var scope = productScope(root);
    document.addEventListener('change', function (ev) {
      if (!ev.target || !scope.contains(ev.target)) return;
      if (ev.target.matches && ev.target.matches('input[type="radio"]')) {
        setTimeout(function () { syncSizeBells(root); }, 80);
      }
    });
    setInterval(function () { syncSizeBells(root); }, 1200);
    syncSizeBells(root);
  }

  function boot() {
    // Capture: label/radio tıklamasından önce yakala
    document.addEventListener('click', onBellActivate, true);
    document.addEventListener('mousedown', onBellActivate, true);
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeModal(getRoot());
    });
    document.querySelectorAll('[data-bis-root]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
